import { Collection } from "@mcleod/core";
import { Component } from "@mcleod/components";

export class ComponentPropertySorter {
    localProps: Collection<any> = {};
    databoundProps: Collection<any> = {};
    otherProps: Collection<any> = {};
    allCompProps: Collection<any> = {};

    constructor(component: Component) {
        const propDefs = component.getPropertyDefinitions();
        this.sort(propDefs);
    }

    private sort(propDefs: any) {
        Object.entries(propDefs).forEach(([key, value]) => {
            const propName = key as string;
            const propDef = value as any;
            const propSource = propDef.source as string;
            if (propSource == null)
                this.localProps[propName] = propDef;
            else if (propSource === "component")
                this.allCompProps[propName] = propDef;
            else if (propSource === "databound")
                this.databoundProps[propName] = propDef;
            else
                this.otherProps[propName] = propDef;
        });
    }
}
